import {
  useIssueCounts,
  useOpenConflictCount,
  useScope,
  useUpkeepCount,
} from "@/lib/queries";
import type { Area } from "./navItems";

type Count = { n: number; alarm: boolean };

/**
 * Counts per section, and per area as the sum of its sections. An area is
 * red when any of its sections is: a conflict, an urgent or overdue repair.
 */
export function useCounts(): {
  section: Record<string, Count>;
  area: Partial<Record<Area["id"], Count>>;
} {
  const { scope } = useScope();
  const conflicts = useOpenConflictCount(scope).data ?? 0;
  const issues = useIssueCounts(scope).data;
  const count = useUpkeepCount(scope).data;
  const checks = count?.n ?? 0;
  const repairs = {
    n: issues?.open ?? 0,
    alarm: !!issues && issues.urgent + issues.overdue > 0,
  };
  return {
    section: {
      "/desk/conflicts": { n: conflicts, alarm: true },
      "/checks/review": { n: count?.review ?? 0, alarm: !!count?.warned },
    },
    area: {
      desk: { n: conflicts, alarm: true },
      checks: { n: checks, alarm: false },
      repairs,
    },
  };
}
